// extracted by mini-css-extract-plugin
module.exports = {"search-menu-item-wrapper":"SearchMenuItem_search-menu-item-wrapper__9_0kq","search-menu-item":"SearchMenuItem_search-menu-item__OoPb_"};